import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnvSetting } from '../utils/env-setting';

@Injectable()
export class CurrentLanguage {
  public LanguageList: any[];
  currentLang: string;
  public currentLanguage: BehaviorSubject<string>;

  constructor() {
    if (EnvSetting.language.LanguageOverRule) {
      this.currentLang = EnvSetting.language.LanguageOverRuleDefault
      this.currentLanguage = new BehaviorSubject<string>(this.currentLang);
    }
    else {
      this.currentLang = EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
      this.currentLanguage = new BehaviorSubject<string>(this.currentLang);
    }
  }
  //   public currentLanguage: BehaviorSubject<string> = new BehaviorSubject<string>(this.cookieservice.get('userSelectedLanguage'));
  public appointmentList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public appointmentListCount: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public breadcrumbs: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public cultureCodeSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public versionSubject: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public vatSubject: BehaviorSubject<any> = new BehaviorSubject<any>(0);
  public userLoggedIn: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public timeZoneStandradName: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public featureList: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public callHistoryId: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public vehicleAdd: BehaviorSubject<any> = new BehaviorSubject<any>(0);
}